import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 20a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.828a2 2 0 0 0-.586-1.414l-3.828-3.828A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2zM14 4l4 4h-3a1 1 0 0 1-1-1zM9.709 14.717c0-.938-.714-1.617-1.722-1.617H6.125V18h1.19v-1.652h.672c1.008 0 1.722-.679 1.722-1.631m-1.183 0c0 .287-.224.497-.539.497h-.672v-.98h.672c.315 0 .539.203.539.483m3.389-1.617c1.428 0 2.506 1.036 2.506 2.429 0 1.421-1.078 2.471-2.506 2.471h-1.73v-4.9zm.084 3.766c.7 0 1.204-.567 1.204-1.337 0-.749-.497-1.295-1.204-1.295h-.623v2.632zm2.938-3.766h3.08v1.134h-1.89v.868h1.687v1.134h-1.687V18h-1.19z",
      clipRule: "evenodd"
    }
  )
);
var SvgPdfFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PdfFilled_default = SvgPdfFilled;

export { PdfFilled_default as default };
